"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAutoLayoutStatusToSnackbarKey = mapAutoLayoutStatusToSnackbarKey;
/**
 * Maps a backend AutoLayoutStatus to the corresponding snackbar status key.
 * Returns null if the status doesn't have an associated snackbar.
 */
function mapAutoLayoutStatusToSnackbarKey(status) {
    switch (status) {
        case "started":
        case "restarted":
        case "generating":
            return "routing";
        case "paused":
            return "paused";
        case "converged":
        case "timeout":
            return "complete";
        case "outOfCredit":
            return "noCredits";
        case "failed":
            return "failed";
        default:
            return null;
    }
}
//# sourceMappingURL=snackbar.js.map